// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__K6cx_","tooltip__tip":"styles_tooltip__tip__MqwC2"};